import { ChangeDetectionStrategy, Component } from "@angular/core";
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from "@medsurf/flat-facades";

@Component({
    selector: 'medsurf-slide-edit-bulk-edit',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './bulk-edit.component.html',
    styleUrls: ['./bulk-edit.component.scss'],
    standalone: false
})
export class BulkEditComponent {
  readonly FlatModels = FlatModels;
  
  constructor(public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
              public bulkEditAuthorFacade: FlatFacades.BulkEditAuthorFacade) {
  }
}
